/**
 * A list of blacklisted to omit when rendering UI layers
 * @type {String[]}
 */
const BLACKLISTED_PROPS = [
    'rootId',
    'layers',
    'name',
    'layerId',
    'project',
    'layerType',
    'layerRole',
    'isSelected',
    'originalId',
    'activeLayer',
    'variationId',
    'curvatureAngle',
    'fontUrl',
    'onUpdate'
];

module.exports = {
    BLACKLISTED_PROPS
};
